<template>
  <div>
    <div class="row">
      <div class="col-lg-8">
        <unit-main :unit="unit" v-on:complete-unit="completeUnit" />
      </div>
      <div class="col-lg-4">
        <!-- start of progress bar -->
        <unit-progress
          :unit-progress-render="unitProgressRender"
          :progress="progress"
          :type="'Playlist'"
        />
        <related-units id="unit-page__related" :unitId="unitId">
        </related-units>
      </div>
    </div>
  </div>
</template>
<script>
import {
  filter as _filter,
  findIndex as _findIndex,
  find as _find,
  forOwn as _forOwn,
  isEmpty as _isEmpty,
} from 'lodash-es';

import UnitPlaylist from './dialog-box/UnitPlaylist.vue';
import RelatedUnits from './UnitPage/RelatedUnits.vue';
import UnitProgress from './UnitPage/Progress.vue';
import UnitMain from './UnitPage/Main.vue';

export default {
  name: 'PlaylistUnitPage',

  components: {
    RelatedUnits,
    UnitPlaylist,
    UnitProgress,
    UnitMain,
  },

  data: () => ({
    unit: null,
    isFetching: false,
    progress: 0,
    unitProgress: [
      {
        type: 'videoWatched',
        title: 'Watched the Video',
        description: 'you will be scored once you played the video',
        checked: false,
        hide: false,
      },
      {
        type: 'videoCompleted',
        title: 'Finished the Video',
        description:
          'you will be scored once you finished watching the whole video',
        checked: false,
        hide: false,
      },
      {
        type: 'quizCompleted',
        title: 'Answered the Quiz',
        description: 'you will be scored once you answered the provided quiz',
        checked: false,
        hide: false,
      },
      {
        type: 'completedUnit',
        title: 'Completed the Unit',
        description: 'you will be scored once you mark the unit as completed',
        checked: false,
        hide: true,
      },
    ],
    isAVideoTypeUnit: true,
  }),

  computed: {
    module() {
      return this.unit.module;
    },
    unitProgressRender() {
      const filtered = _filter(this.unitProgress, { hide: false });

      return _forOwn(filtered);
    },
    played: {
      get() {
        const watchedIndex = 0;
        return this.unitProgress[watchedIndex].checked;
      },
      set() {
        this.checkUnitProgress('videoWatched');
      },
    },
    unitId() {
      return this.$route.params.id;
    },
  },

  created() {
    this.fetchUnit();
  },

  methods: {
    fetchProgress() {
      this.$http
        .get(`/playlist/progress/${Number(this.$route.params.playlistId)}`)
        .then(({ data }) => {
          this.progress = data;
        });
    },
    fetchUnit() {
      this.isFetching = true;
      this.axios
        .get('/client/lms/unit/' + this.unitId)
        .then(({ data }) => {
          this.unit = data.unit;
          this.$store.commit('markAsCompleted/setCurrentUnitId', data.unit.id);
          this.$store.commit('clientUnit/setSelectedItem', data);
          this.isFetching = false;
          this.$store.commit(
            'markAsCompleted/setIsCompleted',
            !!data.is_completed
          );

          if (data.is_played === 1) {
            this.checkUnitProgress('videoWatched');
          }

          if (data.is_completed === 1) {
            this.checkUnitProgress('completedUnit');
          }

          if (data.is_finished_watching === 1) {
            this.checkUnitProgress('videoCompleted');
          }

          if (data.unit.quiz_id) {
            this.isQuizAlreadyAnswered();
          } else {
            this.$store.commit('clientUnit/setQuizResult', null);
            this.hideUnitProgress('quizCompleted');
          }

          // if the Unit is not a video type
          // then just show the "Completed the Unit" task
          if (!data.unit.content.includes('vimeo')) {
            this.isAVideoTypeUnit = false;
            this.hideVideoUnitProgressTasks();
          }

          this.callIntro();
        })
        // .catch(() => {
        //   this.$router.push({
        //     name: 'PageNotFound',
        //   });
        // })
        .finally(() => {
          this.loadVimeoPlayerSettings(this.unit.id);
          this.fetchProgress();
        });
    },

    isQuizAlreadyAnswered() {
      this.axios
        .get(`/client/lms/quiz/${this.unit.quiz.id}`, {
          params: {
            unit_id: this.unit.id,
          },
        })
        .then(({ data }) => {
          this.$store.commit('clientUnit/setQuizResult', data.data);

          if (data.data) {
            this.checkUnitProgress('quizCompleted');
          }
        })
        .catch((error) => {
          this.$store.commit('clientUnit/setQuizResult', null);
        });
    },

    hideUnitProgress(type) {
      const index = _findIndex(this.unitProgress, { type });

      this.unitProgress[index].hide = true;
    },

    hideVideoUnitProgressTasks() {
      const tasks = _forOwn(this.unitProgress);
      const quizCompletedTask = _find(this.unitProgress, {
        type: 'quizCompleted',
      });

      tasks.forEach((item, index) => {
        let value = item.type !== 'completedUnit';

        // if quiz exist in this unit, skip hide of quiz
        if (item.type === 'quizCompleted' && !item.hide) {
          value = false;
        }

        // if item is a "completedUnit" and
        // quiz exist in this unit, hide this item
        if (item.type === 'completedUnit' && !quizCompletedTask.hide) {
          value = true;
        }

        this.unitProgress[index].hide = value;
      });
    },

    loadVimeoPlayerSettings(unitId = null) {
      const player = document.querySelector('#unit-content > iframe');

      this.vPlayer = new Vimeo.Player(player);

      this.vPlayer.on('play', () => {
        this.processPlayedVideo(unitId);
      });

      this.vPlayer.on('ended', () => {
        this.markUnitAsFinishedTheVideo(unitId);
      });
    },

    processPlayedVideo(unitId) {
      const { type } = this.$store.state.relatedUnits;

      if (this.played) {
        return;
      }

      this.$http
        .post('/mark-user-unit-video-played', {
          unit_id: unitId,
          type,
          playlistId: this.$store.state.markAsCompleted.playlist_id,
        })
        .then(() => {
          const completedIndex = 0;

          this.played = true;
          this.unitProgress[completedIndex].checked = true;
        });
    },

    markUnitAsFinishedTheVideo(unitId) {
      const { type } = this.$store.state.relatedUnits;

      this.$http
        .post('/client/lms/unit/finished/watching', {
          unit_id: unitId,
          type,
          playlistId: this.$store.state.markAsCompleted.playlist_id,
        })
        .then(() => {
          this.checkUnitProgress('videoCompleted');
        });
    },

    callIntro() {
      let _this = this;
      setTimeout(function () {
        _this.$_introUnitPage();
      }, 2000);
    },

    checkUnitProgress(type) {
      const index = _findIndex(this.unitProgress, { type });

      this.unitProgress[index].checked = true;
    },

    completeUnit() {
      this.checkUnitProgress('quizCompleted');
      this.checkUnitProgress('completedUnit');
      this.fetchProgress();
    },
  },
};
</script>
